module.exports = __webpack_public_path__ + "assets/img/num-5.7d122807.svg";